module.exports = __webpack_public_path__ + "img/no-message.a9636742.png";